import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/categories';

export default function Categorias() {
  const [q, setQ] = useState('');
  const filtered = categories.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <section className="section page-section">
      <div className="section-header">
        <h1>Todas las categorías</h1>
        <p>Encuentra el proveedor ideal para cada detalle de tu fiesta de XV años.</p>
      </div>
      <div className="page-filter">
        <input
          type="text"
          placeholder="Buscar categoría..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      {filtered.length > 0 ? (
        <div className="category-grid">
          {filtered.map((cat) => (
            <Link to={`/categoria/${cat.slug}`} key={cat.slug} className="category-card">
              <span className="category-icon">{cat.icon}</span>
              <h3>{cat.name}</h3>
              <p>{cat.description}</p>
            </Link>
          ))}
        </div>
      ) : (
        <p className="empty-state">No encontramos categorías con ese nombre.</p>
      )}
    </section>
  );
}
